import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../../contexts/AuthContext';

export default function AuthForm() {
  const navigate = useNavigate();
  const { signInWithGoogle } = useAuth();
  
  const [googleLoading, setGoogleLoading] = useState(false);
  const [error, setError] = useState('');

  const handleBack = () => {
    navigate('/');
  };

  const handleGoogleSuccess = async (credentialResponse: any) => {
    setGoogleLoading(true);
    setError('');
    
    try {
      const result = await signInWithGoogle(credentialResponse.credential);
      
      if (result.linked) {
        // Accounts linked successfully
      }
      
      // Navigate to chat
      navigate('/app/chat');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Google sign-in failed');
    } finally {
      setGoogleLoading(false);
    }
  };

  const handleGoogleError = () => {
    setError('Google sign-in failed. Please try again.');
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 px-4">
      <div className="max-w-md w-full space-y-6">
        {/* Header */}
        <div className="text-center">
          <button
            onClick={handleBack}
            className="text-gray-900 hover:text-gray-700 mb-4"
          >
            ← Back
          </button>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Welcome to Hey Sri Lanka</h1>
          <p className="text-gray-600">Sign in with Google to continue</p>
        </div>

        {/* Google Sign-In - Now the only auth option */}
        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            text="continue_with"
            size="large"
            width="384"
            logo_alignment="left"
          />
        </div>

        {/* Error Message */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-red-600 text-sm">{error}</p>
          </div>
        )}

        {/* Footer */}
        <div className="text-xs text-gray-500 text-center space-y-2">
          <p>
            By continuing, you agree to Hey Sri Lanka's{' '}
            <a href="/terms" className="text-gray-600 hover:text-gray-900 underline transition-colors">
              Terms of Service
            </a>
          </p>
          <div className="flex items-center justify-center gap-3 text-[11px]">
            <a
              href="/privacy"
              className="text-gray-600 hover:text-gray-900 underline transition-colors"
            >
              Privacy Policy
            </a>
            <span className="text-gray-300">•</span>
            <a
              href="/terms"
              className="text-gray-600 hover:text-gray-900 underline transition-colors"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
